import React, { useEffect } from 'react';

const PopupCallback = () => {
  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage(
        { type: "LOGIN_SUCCESS" },
        window.location.origin
      );
      window.close();
    }
  }, []);

  return <div>Logging in...</div>;
}

export default PopupCallback;